import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Dialog, DialogTitle } from '@material-ui/core';
import { Button, Input, Label } from '@ipc/ipc-components';
import React, { useEffect, useRef, useState } from 'react';
import {
  getAllHandlers,
  getIsHandlerPersisted,
  getPersistedHandlerId,
  getRequestHandlerName,
} from '../../../handlers/redux/selectors/HandlersSelectors';
import {
  getAllHandlersRequestActionCreator,
  postCreateNewHandlerRequestActionCreator,
} from '../../../handlers/redux/actions/HandlersActions';
import { AddHandlerDialogStyle } from '../component/AddHandlerDialog.styles';

function CreateNewHandlerDialog(props) {
  const {
    openDialog,
    closeDialog,
    requestHandlerName,
    isHandlerPersisted,
    persistedHandlerId,
    createHandler,
    onSubmit,
    fetchAllHandlers,
    allHandlers,
  } = props;

  const [handler, setHandler] = useState(requestHandlerName || '');
  const [isHandlerUnique, setIsHandlerUnique] = useState(true);
  const previousIsHandlerPersisted = useRef(false);

  const handleOnClose = () => {
    closeDialog();
    setHandler('');
  };

  const onHandlerInputChange = (e) => {
    const duplicateMrdNameControl = (handlerObj) => {
      if (!handlerObj.handlerName) return false;
      return handlerObj.handlerName.toUpperCase() === e.target.value.trim().toUpperCase();
    };
    const isDuplicate = allHandlers.some(duplicateMrdNameControl);
    setIsHandlerUnique(!isDuplicate);
    setHandler(e.target.value);
  };

  const confirmSave = () => {
    createHandler(handler.trim());
  };

  useEffect(() => {
    if (isHandlerPersisted && !previousIsHandlerPersisted.current) {
      const handlerObj = {
        handlerId: persistedHandlerId,
        handlerName: requestHandlerName,
      };
      onSubmit(handlerObj);
      fetchAllHandlers();
      handleOnClose();
    }
    previousIsHandlerPersisted.current = isHandlerPersisted;
  }, [isHandlerPersisted]);

  useEffect(() => {
    if (openDialog) fetchAllHandlers();
  }, [openDialog]);

  return (
    <Dialog onClose={closeDialog} aria-labelledby="simple-dialog-title" open={openDialog}>
      <AddHandlerDialogStyle>
        <DialogTitle id="simple-dialog-title">Create a new Handler</DialogTitle>
        <div className="associate-handler-create-handler-body">
          <div className="form-input-fields">
            <Label>Handler name</Label>
            {handler && !isHandlerUnique && (
              <span className="unique-error">
                Handler name should be unique
              </span>
            )}
          </div>
          <div className="form-input-fields long-input">
            <Input
              type="text"
              value={handler}
              maxLength={50}
              onChange={onHandlerInputChange}
            />
          </div>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={handleOnClose} id="cancel">Cancel</Button>
          <Button
            onClick={confirmSave}
            className={`primary-button-${handler.trim() === '' || !isHandlerUnique} after-box-submit`}
            disabled={handler.trim() === '' || !isHandlerUnique}
            id="submit"
          >
            Submit
          </Button>
        </div>
      </AddHandlerDialogStyle>
    </Dialog>
  );
}

CreateNewHandlerDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool,
  onSubmit: PropTypes.func,
  createHandler: PropTypes.func,
  persistedHandlerId: PropTypes.number,
  requestHandlerName: PropTypes.string,
  isHandlerPersisted: PropTypes.bool,
  fetchAllHandlers: PropTypes.func,
  allHandlers: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    requestHandlerName: getRequestHandlerName(state),
    isHandlerPersisted: getIsHandlerPersisted(state),
    persistedHandlerId: getPersistedHandlerId(state),
    allHandlers: getAllHandlers(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  createHandler: postCreateNewHandlerRequestActionCreator,
  fetchAllHandlers: getAllHandlersRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewHandlerDialog);
